var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-page',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"titlePage"},[_vm._v(" "+_vm._s(_vm._f("translate")('Dashboard','Dashboard'))+" ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }